import React, { useState, useEffect } from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper, LinearProgress, withStyles, makeStyles, Fab, useScrollTrigger, Zoom, Slide, Grow, Fade, useMediaQuery } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';

import './Slider.css';

import en from '../../../language/en/Slider.json';
import es from '../../../language/es/Slider.json';

import { Parallax, Background } from 'react-parallax';

import items from './SliderItemsContent';

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#about');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Zoom in={!trigger}>
      <div onClick={handleClick} role="presentation" >
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

function Slider(props) {
  const [expandIconPos, setExpandIconPos] = useState(window.innerWidth / 2);
  window.addEventListener('resize', () => setExpandIconPos(window.innerWidth / 2));

  // console.log('Client height:', window.innerHeight);
  return (
    <React.Fragment>
      <Carousel interval={400000}>
        {
          items.map((item, i) => <Item key={i} item={item} itemNumber={i + 1} />)
        }
      </Carousel>
      <ScrollTop {...props}>
        <Fab color="secondary" size={useMediaQuery("(max-width: 991px)") ? "small" : "large"} className="FabCssClass" style={{ left: expandIconPos - 25 }}>
          <ExpandMoreIcon fontSize="large" />
        </Fab>
      </ScrollTop>

    </React.Fragment>
  )

}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 2
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    backgroundColor: '#ff1a9099',
  },
}))(LinearProgress);

function Item({ item, itemNumber }) {
  const [maxHeight, setMaxHeight] = useState(window.innerHeight);
  document.body.onresize = () => setMaxHeight(window.innerHeight);

  const [progress, setProgress] = useState(0);
  const [enterTitle, setEnterTitle] = useState(false);
  // const [enterSubTitle, setEnterSubTitle] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((progress) => {
        if (progress === 100) {
          return 0;
        }
        const step = 400 * 100 / 3700;// Math.random() * 10;
        return Math.min(progress + step, 100);
      });
    }, 400);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setEnterTitle(true);

      /* setTimeout(() => {
        setEnterSubTitle(true);
      }, 500); */

    }, 500);
  }, [])

  const growSecuencie = item.description.map((subItemDesc, index) => {
    // const delay = (index + 1) * 500;
    return (
      <Grow in={enterTitle} /* style={{ transitionDelay: delay }} */ style={{ transformOrigin: '0 0 0' }} timeout={1000 * (index / 2 + 1)} key={index}>
        <div className={subItemDesc.className} /* style={subItemDesc.style} */>
          {subItemDesc.text}
        </div>
      </Grow>
    )
  });

  const zoomSecuencie = item.description.map((subItemDesc, index) => {
    const delay = (index + 1) * 500;
    return (
      <Fade in={enterTitle} style={{ transitionDelay: delay, transformOrigin: '0 0 0' }} >
        <div className={subItemDesc.className} /* style={subItemDesc.style} */>
          {subItemDesc.text}
        </div>
      </Fade>
    )
  });
  // console.log('itemNumber...', itemNumber)
  return (
    <Paper elevation={10} style={{ height: maxHeight, width: window.innerWidth }} className="page-slider">

      {/* <BorderLinearProgress variant="determinate" value={progress} /> */}

      <div style={{ background: (item.bgColor ? item.backgroundColor : `url(${item.backgroundImage})`)/*, height: maxHeight - 28, width: window.innerWidth */ }} className="item fullwidthbanner-container" id={item.id}>

        <Slide in={enterTitle} mountOnEnter unmountOnExit>
          <div className={item.title.className} /* style={item.title.style} */>
            {item.title.text}
          </div>
        </Slide>


        {/* <Grow in={enterTitle} /* style={{ transitionDelay: '.5s' }} / style={{ transformOrigin: '0 0 0' }} timeout={1000}>
          <div className={item.description[0].className} style={item.description[0].style}>
            {item.description[0].text}
          </div>
        </Grow> */}
        {(itemNumber === 4) ? zoomSecuencie : growSecuencie}

        <div className={item.images[0].className} >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit timeout={500}>
            <embed src={item.images[0].src} alt="image" style={item.images[0].style} id={item.images[0].id} />
          </Slide>
        </div>

      </div>

    </Paper>
  )
}

export default Slider;
/*
class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: {
        lang: {
          en,
          es
        }
      },
      selectedLanguage: 'en'
    }
  }
  render() {
    const lang = this.state.config.lang;
    const title = (this.state.selectedLanguage === 'en') ? lang.en.title : lang.es.title;

  */